import { render, staticRenderFns } from "./FoodcourtMeal.vue?vue&type=template&id=80aa49fa"
import script from "./FoodcourtMeal.vue?vue&type=script&lang=js"
export * from "./FoodcourtMeal.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtMeal.vue?vue&type=style&index=0&id=80aa49fa&prod&lang=scss"
import style1 from "./FoodcourtMeal.vue?vue&type=style&index=1&id=80aa49fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports